// Typelizer digest 31243e00f528b245e207f912f03e5829
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/bank_syncs/:bank_sync_id/retry */
  create: (
    params: { bankSyncId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/bank_syncs/:bank_sync_id/retry', params, options),
    method: 'post',
  }),
}
